
import React from 'react';
// Link removed
import '../LatestProperties/LatestProperties.css'; // Reusing existing CSS
import '../PropertyCategory/PropertyCategory.css';

interface PropertyCardProps {
    image: string;
    badgeSale: string;
    badgeType: string;
    features: string[];
    title: string;
    location: string;
    price: string;
    isCallPrice?: boolean;
}

const PropertyCard: React.FC<PropertyCardProps> = ({
    image,
    badgeSale,
    badgeType,
    features,
    title,
    location,
    price,
    isCallPrice
}) => {
    return (
        <div className="latest-property-card">
            <div className="latest-property-image">
                <span className="badge-sale">{badgeSale}</span>
                <span className="badge-type">{badgeType}</span>
                <img src={image} alt={title} />
            </div>
            <div className="latest-property-features">
                {features.map((feature, index) => (
                    <span key={index}>{feature}</span>
                ))}
            </div>
            <div className="latest-property-info">
                <h3>{title}</h3>
                <p>{location}</p>
                <span className={`latest-property-price ${isCallPrice ? 'call' : ''}`}>
                    {price}
                </span>
            </div>
        </div>
    );
};

export default PropertyCard;
